<template>
    <div class="dropdown">
        <v-select dir="rtl" multiple label="title" v-model="personGroupValue" placeholder="دسته بندی" :filterable="false" :options="personGroupOptions" @search="onSearchPersonGroup" :reduce="p => p.personGroupId" @update:modelValue="handleInput">
            <template slot="no-options">
                جستجو...
            </template>
            <template slot="option">
                <div class="d-center">
                    {{ option.title }}
                </div>
            </template>
        </v-select>

    </div>
</template>

<script>
    import 'vue-select/dist/vue-select.css';
    export default {
        emits:["update:modelValue"],
        props: ['value', 'firstValue', 'firstValueText'],
        data() {
            return {
                personGroupSearchText: this.firstValueText,
                personGroupValue: this.firstValue,
            };
        },
        computed: {
            personGroupOptions() {
                return this.$store.getters.GetPersonGroupList;
            }
        },
        methods: {
            handleInput(val) {
                this.$emit('update:modelValue', val)
            },
            onSearchPersonGroup(search, loading) {
              
                    loading(true);
                    this.personGroupSearchText = search;
                    this.searchPersonGroup(search);
                    loading(false);
                
            },
            searchPersonGroup() {
                this.$store.dispatch("GetPersonGroupListFromServer", {
                    text: this.personGroupSearchText
                });
            }
        },
        created() {
            this.searchPersonGroup();
        },


    };
</script>